import { PublicationTemplateType } from "../../../../brand/brand-campaign/publication-template/data/entities/publication-templates.entity";
import { SchedulePeriod } from "../../../../brand/brand-campaign/publication-template/domain/models/publication-template";
import { Platform } from "../../../enums/campaignPost.enums";
import { PublicationAggregatedSummary } from "./publication";

export class ScheduleWithSummary {
  constructor(
    public readonly period: SchedulePeriod,
    public readonly summary?: PublicationAggregatedSummary,
  ) {}
}

export class PublicationAggregatedCalendarViewItem {
  constructor(
    public readonly publicationTemplateId: string,
    public readonly publicationTemplateType: PublicationTemplateType,
    public readonly thumbnailUrl: string,
    public readonly campaignId: number,
    public readonly campaignName: string,
    public readonly recommendedSchedules: ScheduleWithSummary[],
    public readonly creatorId: number,
    public readonly creatorName: string,
    public readonly lastPublishedAt: Date,
    public readonly platform: Platform,
  ) {}
}
